import React from "react";
import "./CareerSlider.scss";
import { sliderImages } from "../../data/data";

const CareerSlider = () => {
  return (
    <section className="section careerSlider">
      <h2 className="careerSlider__container--title container">Life</h2>
      <article className="careerSlider__container">
        <div className="careerSlider__container--contents">
          {sliderImages.map((image, index) => (
            <figure
              key={index}
              className="careerSlider__container--contents-items"
            >
              <img
                src={image.src}
                width={image.width}
                height={image.height}
                alt={image.alt}
              />
            </figure>
          ))}
        </div>
      </article>
      <h3 className="careerSlider__container--subtitle container">
        At Radiksez
      </h3>
    </section>
  );
};

export default CareerSlider;
